import { apiPath } from "@/api/api-path"
import qs from "qs"
import api from "../service"

export async function getTicketEscalationList(filter) {
  return api
    .get(apiPath.getTicketEscalationList, {
      params: filter,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getTicketEscalationById(id) {
  const path = apiPath.getTicketEscalationById.replace("{id}", id)
  return api
    .get(path, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getTicketEscalationEventList(filter) {
  return api
    .get(apiPath.getTicketEscalationEventList, {
      params: filter,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function createNewTicketEscalation(newTicketEscalation) {
  return api
    .post(apiPath.ticketEscalationCreate, newTicketEscalation, {})
    .then((response) => {
      if (response.status === 201) return response.data
    })
    .catch((error) => {
      throw error
    })
}

export async function updateTicketEscalation(id, ticketEscalation) {
  const path = apiPath.updateTicketEscalationById.replace("{id}", id)
  return api
    .put(path, ticketEscalation, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

export async function deleteTicketEscalation(id) {
  return api
    .delete(apiPath.deleteTicketEscalation + id, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

export async function getTicketEscalationActiveList() {
  return api
    .get(apiPath.getTicketEscalationActiveList, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getTicketEscalationByTicketId(id) {
  const path = apiPath.getTicketEscalationByTicketId.replace("{ticketId}", id)
  return api
    .get(path, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function escalateTicketEscalationByTicketId(ticketId) {
  const path = apiPath.escalateTicketEscalationByTicketId.replace(
    "{ticketId}",
    ticketId
  )

  return api
    .post(path, { ticketId }, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

export async function getEscalationEventList(filter) {
  return api
    .get(apiPath.getEscalationEventList, {
      params: {
        ...filter,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}
